module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAPZJREFUOBFjYBgFBENg1qxZftu2bWPHpZAJlwRIfObMmfH///+3efz48RQgjVUtVkGoZm9GRkb59PT0MmZm5gWzZ8/uwWcZitzcuXMtgU6fgCwI5PsAXVSLLAZiY7hg3rx5Wn///k0WEBAoRlaclpa2Beiix0BDMpHFUQwAapb98+dPFSsra05YWNhfZIUgNtCQBUBDuIGGhMLk4AYsXLhQGKi5CxhY2YmJiT9gCtBpoCGgsDCaM2eOM0iOEUQsWrSI+8ePH7OBNhcBNb8AieEDQEsYgWEyFahmDtgFQAEBoNOqidEMMhio9j+QymdiYmID8Yc4AAB+0VqZr6W4WwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_icon_retract.png
// module id = 822
// module chunks = 121